import { gql } from 'apollo-angular';
import BASIC_DATA_FIELDS from './segments/basic-data-fields';

const GET_RFP = gql`
  query getRfp($rfpId: Long!) {
    rfp(id: $rfpId) {
      ${BASIC_DATA_FIELDS}
      hasPartialCategories
      primaryCategories {
        id
        name
      }
      leafNodeCategories {
        id
        name
      }
      spend {
        actualSpend
        continuedSpend
        annualizedSpend
      }
      potentialSavings {
        savingsVolume
      }
      statistics {
        sellerCount
        participantCount
        systemCount
        leafCategoryCount
        recipientCount
        productCount
        primaryCategoryCount
        recipientStatistics {
          leafCategoryCount
          primaryCategoryCount
        }
      }
    }
  }
`;

export default GET_RFP;
